import clsx from "clsx";
import type {
  AssetPosition,
  GatewayState,
  InputOutputModuleStateOutput,
} from "kubb";
import { startCase } from "lodash-es";
import type React from "react";
import type { Asset } from "utils/object";
import { Badge } from "../../../components/Theme/badge.tsx";
import UncontrolledTooltip from "../../../components/Theme/tooltip.tsx";
import GatewayStateLabel from "./gateway/GatewayStateLabel";
import RelayStateLabel from "./input_output_module/RelayStateLabel";

function AssetPositionIssueBadge({
  assetPosition,
  className,
  ...rest
}: {
  assetPosition: AssetPosition;
  size?: "sm" | "md" | "lg";
} & Omit<React.HTMLAttributes<HTMLSpanElement>, "color">): React.ReactElement {
  if (
    assetPosition.open_issues === undefined ||
    assetPosition.open_issues.length === 0
  ) {
    return (
      <Badge {...rest} className={clsx(className, "h-6")} color={"green"}>
        ok
      </Badge>
    );
  } else {
    const errorText = assetPosition.open_issues.map((v) =>
      startCase(v.category.split(".")[1].toLowerCase()),
    );
    return (
      <div>
        <UncontrolledTooltip message={`Errors: ${errorText}`}>
          <Badge {...rest} className={clsx(className, "h-6")} color={"red"}>
            error
          </Badge>
        </UncontrolledTooltip>
      </div>
    );
  }
}

export default function AssetStateLabel(
  props: {
    asset?: Asset;
    assetPosition?: AssetPosition;
    size?: "sm" | "md" | "lg";
  } & React.HTMLAttributes<HTMLSpanElement>,
): React.ReactElement {
  const { asset, assetPosition, ...rest } = props;

  const relay = asset?.asset_type === "input_output_module";
  const gateway = asset?.asset_type === "gateway";
  const receiver = asset?.asset_type === "wireless_receiver";

  if (asset?.state) {
    if (relay) {
      return (
        <RelayStateLabel
          state={(asset.state as InputOutputModuleStateOutput).relay_state}
          {...rest}
        />
      );
    } else if (gateway || receiver) {
      return (
        <GatewayStateLabel
          state={(asset.state as GatewayState).configuration_state}
          {...rest}
        />
      );
    }
  }
  if (assetPosition) {
    return <AssetPositionIssueBadge assetPosition={assetPosition} {...rest} />;
  }
  return <></>;
}
